import React from "react";

import { GacDesktopNavbarItem } from "@components/Catalyst/navbar";
import { Bars3Icon } from "@heroicons/react/20/solid";
import { BrandCode } from "@typed/common";
import { BrandConfigByCode } from "@constants/common";
import { FaCaretDown } from "react-icons/fa";

const MobileNavbar = ({
  brandCode,
  showSASidebarClicked,
  showMenuSidebarClicked,
}: {
  brandCode: BrandCode;
  showSASidebarClicked: () => void;
  showMenuSidebarClicked: () => void;
}) => {
  const { brandLogo, bgColor, logoAlt, url } = BrandConfigByCode[brandCode];

  return (
    <header
      className={`dark flex w-full items-center ${brandCode === "gac" ? "bg-black" : `bg-[linear-gradient(122.25deg,_${bgColor}_75%,_#000000_75%)]`} lg:hidden`}
    >
      <div>
        <a href={url}>
          <div className="h-14">
            <img src={brandLogo} alt={logoAlt} className="h-14" />
          </div>
        </a>
      </div>
      <div className="flex-1" />
      <div className="flex items-center align-middle">
        <GacDesktopNavbarItem onClick={showSASidebarClicked} aria-label="Open Studio Assistant Menu">
          <div className="flex items-center gap-1">
            <img className="h-7 w-7" width={28} height={28} src="/images/logos/Stud_grn.svg" alt="Studio Assistant" />
            <FaCaretDown size={18} />
          </div>
        </GacDesktopNavbarItem>

        <GacDesktopNavbarItem onClick={showMenuSidebarClicked} aria-label="Open Main Site navigation">
          <Bars3Icon />
        </GacDesktopNavbarItem>
      </div>
    </header>
  );
};

export default MobileNavbar;
